import { render, staticRenderFns } from "./CenterRightAnimation.vue?vue&type=template&id=98a5c5b4&scoped=true"
import script from "./CenterRightAnimation.vue?vue&type=script&lang=js"
export * from "./CenterRightAnimation.vue?vue&type=script&lang=js"
import style0 from "./CenterRightAnimation.vue?vue&type=style&index=0&id=98a5c5b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a5c5b4",
  null
  
)

export default component.exports